import { Action } from 'redux'
import { IFormValues } from '../../../containers/Form/CreateRoom'
import { IRoom } from '../../../models/Room'
import { RoomActions } from '../../../reducers/bookingCalendar/actionNames'

const requestCreateRoom = (
  room: IFormValues,
  formName: string,
): IRequestCreateRoom => ({
  formName,
  room,
  type: RoomActions.RequestCreateRoom,
})

export interface IRequestCreateRoom
  extends Action<RoomActions.RequestCreateRoom> {
  room: IFormValues
  formName: string
}

const roomWasCreated = (room: IRoom): IRoomWasCreated => ({
  room,
  type: RoomActions.RoomWasCreated,
})

export interface IRoomWasCreated extends Action<RoomActions.RoomWasCreated> {
  room: IRoom
}

export { roomWasCreated }
export default requestCreateRoom
